const axios = require('axios')

const client = axios.create({
    baseURL: process.env.REACT_APP_API_URL
})

module.exports = client



